var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ticket-search", {
    attrs: {
      "delete-case": _vm.deleteCase,
      "download-document": _vm.downloadDocument,
      "get-case-documents": _vm.getUserCaseById,
      "get-comment-history": _vm.getCommentHistory,
      "get-status": _vm.getUserCaseStatus,
      "get-user-cases": _vm.getUserCases,
      "save-additional-info": _vm.saveAdditionalInfo,
      "status-id": _vm.statusId
    },
    on: { "on-open-case": _vm.onOpenCaseHandler }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }